export default {
  computed: {
    financialReports() {
      return this.report.companyoverview.financials.slice(0, this.maxNumberOfFinancialsToShow);
    },
  },
  data() {
    return {
      maxNumberOfFinancialsToShow: 5,
    };
  },
  methods: {
    extraClasses(financialsIndex, financialsKey) {
      if (this.showDiff) {
        if (financialsIndex === 0) {
          const c = this.financialReports[0][financialsKey];
          const p = this.financialReports[1][financialsKey];
          if (c !== p) {
            return 'diff-new';
          }
          return 'diff-same';
        }
        if (financialsIndex === 1) {
          const c = this.financialReports[0][financialsKey];
          const p = this.financialReports[1][financialsKey];
          if (c !== p) {
            return 'diff-old';
          }
          return 'diff-same';
        }
      }

      return '';
    },
  },
  props: {
    report: {
      required: true,
      type: Object,
    },
    showDiff: {
      required: true,
      type: Boolean,
    },
  },
};
